import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import {
  getBioCountryOfDestination,
  getBioCountryOfOrigin,
  getBreedSpeciesSpecimensDetails,
  getCAVSMaster,
} from "../../api/apimethods";
import { IBioPurposeOfTest } from "../../typings/models/BioPurposeOfTest";
import Container from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import Stepwizard from "./Helper/Stepwizard";
import Header from "../../components/molecules/Header/Header";
import PersonalInformation from "./Helper/ProfileInformation";
import { IAquaApplicationDetails } from "../../typings/models/AquaApplicationDetails";
import { IAquaSamplesAndTests } from "../../typings/models/AquaSamplesAndTests";
import { IAquaClinicalHistoryDisease } from "../../typings/models/AquaClinicalHistoryDisease";
import moment from "moment";
import { IAquaRequest } from "../../typings/interfaces/Requests/AquaRequest";
import { AquaMetaContext } from "../../App";
import { IAquaPreference } from "../../typings/models/AquaPreference";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import React from "react";
import { ILabBreedMaster } from "../../typings/models/LabBreedMaster";
import { ILabSpeciesMaster } from "../../typings/models/LabSpeciesMaster";
import { ILabSpecimenMaster } from "../../typings/models/LabSpecimenMaster";
import { IReactSelectOption } from "../../typings/models/ReactSelectOption";
import Select from "react-select";
import Loader from "../../components/molecules/Loader";
import { NotifyType } from "../../utils/app-config";
import { notify } from "../../utils";
const stepWizardConfig: IStepwizardProps = {
  currentStep: 3,
  steps: [
    {
      name: "Choose Application",
    },

    {
      name: "Samples & Tests",
    },
    {
      name: "Review",
    },
    {
      name: "Cost & Confirm",
    },
    {
      name: "Acknowledgement",
    },
  ],
};

const CAVSAquaReview = () => {
  let bannerName = "Application for Laboratory Testing";
  const location = useLocation();
  const navigate = useNavigate();
  const { aquaMeta } = useContext(AquaMetaContext);
  const [purposeOfTestOptions, setPurposeOfTestOptions] =
    useState<IBioPurposeOfTest[]>();
  const [pageLoader, setPageLoader] = useState<boolean>(false);

  const [samplesToBeCollectedOptions, setSamplesToBeCollectedOptions] =
    useState<IBioPurposeOfTest[]>();
  const [diseasePatternOptions, setDiseasePatternOptions] =
    useState<IBioPurposeOfTest[]>();
  const [noOrDiseasedOptions, setNoOrDiseasedOptions] =
    useState<IBioPurposeOfTest[]>();
  const [totalNoOfUnitsOptions, setTotalNoOfUnitsOptions] =
    useState<IBioPurposeOfTest[]>();
  const [breedSelectOptions, setBreedSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [countryOptions, setCountryOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [premisesCodeOptions, setpremisesCodeOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [specimenSelectOptions, setSpecimenSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [bioSurveillanceProgramsOptions, setBioSurveillanceProgramsOptions] =
    useState<IReactSelectOption[]>([]);
  const [unitSizeOptions, setUnitSizeOptions] = useState<IBioPurposeOfTest[]>();
  const [farmAreaOptions, setFarmAreaOptions] = useState<IBioPurposeOfTest[]>();
  const [ageAffectedOptions, setAgeAffectedOptions] =
    useState<IBioPurposeOfTest[]>();
  const [clinicalHistoryOptions, setClinicalHistoryOptions] =
    useState<IBioPurposeOfTest[]>();
  const [showFarmDetails, setShowFarmDetails] = useState(false);
  const [showAdditionalContent, setShowAdditionalContent] = useState(false);
  const [applicationDetails, setApplicationDetails] =
    useState<IAquaApplicationDetails>();
  const [samples, setSamples] = useState<IAquaSamplesAndTests[]>();
  const [clinicalHistory, setClinicalHistory] =
    useState<IAquaClinicalHistoryDisease>();
  const [myPreference, setMyPreference] = useState<IAquaPreference>();
  const [showGroupAnimals, setShowGroupAnimals] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const { message } = notify();
  const [countryOfOriginOptions, setCountryOfOriginOptions] =
    useState<ICodeMasterModel[]>();
  const [isVaccinationHistoryExpanded, setIsVaccinationHistoryExpanded] =
    useState(false);
  const [countryOfDestinationOptions, setCountryOfDestinationOptions] =
    useState<ICodeMasterModel[]>();
  const [showPostMortem, setShowPostMortem] = useState(false);
  const [animalDetails, setShowanimalDetails] = useState(false);
  const [showQuarantineInfo, setShowQuarantineInfo] = useState(false);
  const [speciesOptions, setSpeciesOptions] = useState<ILabSpeciesMaster[]>();
  const [breedOptions, setBreedOptions] = useState<ILabBreedMaster[]>();
  const [specimenOptions, setSpecimenOptions] =
    useState<ILabSpecimenMaster[]>();
  const [speciesSelectOptions, setSpeciesSelectOptions] = useState<
    IReactSelectOption[]
  >([]);
  const toggleQuarantineInfo = () => {
    setShowQuarantineInfo((prev) => !prev);
  };
  useEffect(() => {
    getMaster();
  }, []);
  const getMaster = async () => {
    try {
      setPageLoader(true);
      const response = await getCAVSMaster();
      if (response.status === 200) {
        let cavsMaster = response.data;
        let bioMaster = cavsMaster.bioMasters;
        if (bioMaster) {
          const bioSurveillanceProgram = bioMaster.bioSurveillancePrograms;
          if (bioSurveillanceProgram) {
            const bioSurveillanceProgramArr = bioSurveillanceProgram.map(
              (result: any) => ({
                label: result.name,
                value: result.CodeValue,
              })
            );
            setBioSurveillanceProgramsOptions(bioSurveillanceProgramArr);
            const premisesMaster = bioMaster?.premisesMaster || [];
            const premisesCodeOptions = premisesMaster.map((result: any) => ({
              label: result.premisesCode,
              value: result.premisesCode,
            }));

            setpremisesCodeOptions(premisesCodeOptions);
          }
        }
        let purposeOfTest = response?.data?.bioMasters?.testPurpose;
        if (purposeOfTest) {
          let values: number[] = Object.values(purposeOfTest);
          let purposeOfTestArr: IBioPurposeOfTest[] = Object.keys(
            purposeOfTest
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setPurposeOfTestOptions(purposeOfTestArr);
        }
        // samples to be collected or submitted
        let samplesToBeCollected = response?.data?.bioMasters?.samplesCollSub;
        if (samplesToBeCollected) {
          let values: number[] = Object.values(samplesToBeCollected);
          let samplesToBeCollectedArr: IBioPurposeOfTest[] = Object.keys(
            samplesToBeCollected
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setSamplesToBeCollectedOptions(samplesToBeCollectedArr);
        }
        // Disease pattern
        let diseasePattern = response?.data?.bioMasters?.diseasePattern;
        if (diseasePattern) {
          let values: number[] = Object.values(diseasePattern);
          let diseasePatternArr: IBioPurposeOfTest[] = Object.keys(
            diseasePattern
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setDiseasePatternOptions(diseasePatternArr);
        }
        let noOrDiseased = response?.data?.bioMasters?.noOrDisease;
        if (noOrDiseased) {
          let values: number[] = Object.values(noOrDiseased);
          let noOrDiseasedArr: IBioPurposeOfTest[] = Object.keys(
            noOrDiseased
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setNoOrDiseasedOptions(noOrDiseasedArr);
        }
        let totalNoOfUnits = response?.data?.bioMasters?.totalNoOfUnits;
        if (totalNoOfUnits) {
          let values: number[] = Object.values(totalNoOfUnits);
          let totalNoOfUnitsArr: IBioPurposeOfTest[] = Object.keys(
            totalNoOfUnits
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setTotalNoOfUnitsOptions(totalNoOfUnitsArr);
        }

        let unitSize = response?.data?.bioMasters?.unitSize;
        if (unitSize) {
          let values: number[] = Object.values(unitSize);
          let unitSizeArr: IBioPurposeOfTest[] = Object.keys(unitSize).map(
            (x, ind) => {
              return {
                id: values[ind],
                name: x,
              };
            }
          );
          setUnitSizeOptions(unitSizeArr);
        }
        let farmArea = response?.data?.bioMasters?.farmArea;
        if (farmArea) {
          let values: number[] = Object.values(farmArea);
          let farmAreaArr: IBioPurposeOfTest[] = Object.keys(farmArea).map(
            (x, ind) => {
              return {
                id: values[ind],
                name: x,
              };
            }
          );
          setFarmAreaOptions(farmAreaArr);
        }
        let ageAffected = response?.data?.bioMasters?.ageAffected;
        if (ageAffected) {
          let values: number[] = Object.values(ageAffected);
          let ageAffectedArr: IBioPurposeOfTest[] = Object.keys(
            ageAffected
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setAgeAffectedOptions(ageAffectedArr);
        }

        const countryRes = await getBioCountryOfDestination();
        setCountryOfDestinationOptions(countryRes?.data || []);
        setPageLoader(false);

        const conutryRes = await getBioCountryOfOrigin();
        setCountryOfOriginOptions(conutryRes?.data || []);
        setPageLoader(false);
        const countryOptions = (conutryRes?.data || []).map((country) => ({
          value: country.name,
          label: country.name,
        }));
        setCountryOptions(countryOptions);

        let clinicalHistory = response?.data?.bioMasters?.clinicalHistory;
        if (clinicalHistory) {
          let values: number[] = Object.values(clinicalHistory);
          let clinicalHistoryArr: IBioPurposeOfTest[] = Object.keys(
            clinicalHistory
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setClinicalHistoryOptions(clinicalHistoryArr);
        }
      }

      const breedspeciesresponse = await getBreedSpeciesSpecimensDetails("AQU");

      if (breedspeciesresponse.status === 200) {
        let species = breedspeciesresponse?.data?.labSpecies;

        if (species) {
          let values: any[] = Object.values(species);
          let speciesArr: any[] = Object.keys(species).map((x, ind) => {
            return {
              speciesName: values[ind].speciesName,
            };
          });
          setSpeciesOptions(speciesArr);
        }

        let breeds = breedspeciesresponse?.data?.labBreed;

        if (breeds) {
          let values: any[] = Object.values(breeds);
          let breedArr: any[] = Object.keys(breeds).map((x, ind) => {
            return {
              breedName: values[ind].breedName,
            };
          });
          setBreedOptions(breedArr);
        }

        let specimens = breedspeciesresponse?.data?.labSpecimen;

        if (specimens) {
          let values: any[] = Object.values(specimens);
          let specimensArr: any[] = Object.keys(specimens).map((x, ind) => {
            return {
              labSpecimenDescription: values[ind].labSpecimenDescription,
            };
          });
          setSpecimenOptions(specimensArr);
        }
      }

      const meta: IAquaRequest = aquaMeta.aquaMeta;
      if (Object.keys(meta)?.length) {
        setSamples(meta.labAQUASampleTestDetails);
        setApplicationDetails(meta.labAQUAApplicationDetails);
        setClinicalHistory(
          meta?.labAQUAApplicationDetails?.clinicalHistoryDisease
        );
        setMyPreference(meta?.labAQUAPreference);
      }

      setPageLoader(false);
    } catch (ex) {
      console.error(ex);
      setPageLoader(false);
    }
  };
  useEffect(() => {
    if (speciesOptions) {
      const speciesOpts = [
        ...speciesOptions.map((species) => ({
          label: species.speciesName,
          value: species.speciesName,
        })),
        { label: "Others", value: "Others" },
      ];
      setSpeciesSelectOptions(speciesOpts);
    }

    if (breedOptions) {
      const breedOpts = [
        ...breedOptions.map((breed) => ({
          label: breed.breedName,
          value: breed.breedName,
        })),
        { label: "Others", value: "Others" },
      ];
      setBreedSelectOptions(breedOpts);
    }

    if (specimenOptions) {
      const specimenOpts = [
        ...specimenOptions.map((specimen) => ({
          label: specimen.labSpecimenDescription,
          value: specimen.labSpecimenDescription,
        })),
        { label: "Others", value: "Others" },
      ];
      setSpecimenSelectOptions(specimenOpts);
    }
  }, [speciesOptions, breedOptions, specimenOptions]);
  const handleDiseaseSignClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowAdditionalContent(!showAdditionalContent);
  };
  const handleToggleForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowForm((prevShowForm) => !prevShowForm);
  };
  const handleToggleFarmDetails = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    setShowFarmDetails((prevShowFarmDetails) => !prevShowFarmDetails);
  };
  const handleToggleAnimalDetails = (
    e: React.MouseEvent<HTMLAnchorElement>
  ) => {
    e.preventDefault();

    setShowanimalDetails((prevShowAnimalDetails) => !prevShowAnimalDetails);
  };

  const handlePreviousClick = async () => {
    const meta: IAquaRequest = aquaMeta.aquaMeta;
    const applicationNumber = meta?.applicationNumber;
    const actionStatus = meta?.actionStatus;
    localStorage.setItem("ismetadata", "1");
    if (applicationNumber && actionStatus) {
      const url = `/aqua-samples-and-tests?an=${applicationNumber}&type=${actionStatus}`;

      navigate(url);
    } else {
      navigate("/aqua-samples-and-tests");
    }
  };

  const toggleVaccinationHistory = () => {
    setIsVaccinationHistoryExpanded((prev) => !prev);
  };

  const handleNextClick = () => {
    const modeOfPayment = localStorage.getItem("modeOfPayment");
    const meta: IAquaRequest = aquaMeta.aquaMeta;
    const purposeOfTest = meta?.labAQUAApplicationDetails?.purposeOfTest;

    if (purposeOfTest === 1 && modeOfPayment !== "Biosurveillance") {
      setErrorMessage(
        "You cannot proceed with Biosurveillance as the purpose of the test with other than Biosurveillance as the payment mode. Please select Biosurveillance as the payment mode or edit the purpose of the test in step 2."
      );
      message(NotifyType.Error, "Please check the error message.");
      return;
    }

    if (modeOfPayment === "Biosurveillance" && purposeOfTest !== 1) {
      setErrorMessage(
        "You cannot proceed with a Purpose of Application other than Biosurveillance since the payment mode is Biosurveillance. Please change the payment mode or edit the purpose of the test in step 2."
      );
      message(NotifyType.Error, "Please check the error message.");
      return;
    }

    setErrorMessage("");
    navigate("/aqua-cost-and-confirm");
  };

  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab">{bannerName} </div>
        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />
        {errorMessage && (
          <div className="info-content">
            <div className="att">
              <br />
              <div className="text-danger">
                <center>{errorMessage}</center>
              </div>
            </div>
          </div>
        )}
        <PersonalInformation />
        <div className="personal-info">
          <div className="info-heading">
            <h2 className="info-h3">Sample Details</h2>
          </div>
          {pageLoader ? (
            <Loader />
          ) : (
            <div className="info-content">
              <div className="row">
                <div className="row mt-2">
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <label className="form-check-label" htmlFor="">
                          Purpose of Application
                          <span className="star-red">*</span>
                        </label>
                      </div>
                      <div className="col-lg-6">
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          name="purposeOfTest"
                          value={applicationDetails?.purposeOfTest}
                          disabled
                        >
                          <option selected>-- Select --</option>
                          {purposeOfTestOptions &&
                            purposeOfTestOptions.map((x) => {
                              return <option value={x.id}>{x.name}</option>;
                            })}
                        </select>

                        {applicationDetails?.purposeOfTest === 7 && (
                          <div className="col-lg-12 mt-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Purpose of Application"
                              name="otherPurposeOfTest"
                              value={applicationDetails?.otherPurposeOfTest}
                              disabled
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <label htmlFor="crossReference">Cross Reference</label>
                      </div>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          id="crossReference"
                          name="crossReference"
                          value={applicationDetails?.crossReference}
                          className="form-control"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {applicationDetails?.purposeOfTest === 1 && (
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-lg-6">
                          <label className="form-check-label" htmlFor="">
                            Biosurveillance Program
                            <span className="star-red">*</span>
                          </label>
                        </div>
                        <div className="col-lg-6">
                          <div className="col-lg-12 mt-2">
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              name="bioSurveillanceProgram"
                              value={applicationDetails?.bioSurveillanceProgram}
                              disabled
                            >
                              <option selected>-- Select --</option>
                              {bioSurveillanceProgramsOptions &&
                                bioSurveillanceProgramsOptions.map((x) => {
                                  return (
                                    <option value={x.label}>{x.label}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="row mt-2">
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <label className="form-check-label" htmlFor="">
                          Country of Origin <span className="star-red">*</span>
                        </label>
                      </div>
                      <div className="col-lg-6">
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          name="countryOfBirth"
                          disabled
                          value={applicationDetails?.countryOfBirth}
                        >
                          <option selected>-- Select --</option>
                          {countryOfOriginOptions &&
                            countryOfOriginOptions.map((x) => {
                              return <option value={x.name}>{x.name}</option>;
                            })}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <label htmlFor="exportercountryOfDestination">
                          Country of Destination
                        </label>
                      </div>
                      <div className="col-lg-6">
                        <select
                          id="countryOfDestination"
                          name="countryOfDestination"
                          value={applicationDetails?.countryOfDestination}
                          className="form-control"
                          disabled
                        >
                          <option value="" disabled hidden>
                            Choose a Country
                          </option>
                          {countryOfDestinationOptions &&
                            countryOfDestinationOptions.map((x) => {
                              return <option value={x.name}>{x.name}</option>;
                            })}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-3">
                    <label className="form-check-label" htmlFor="">
                      Date of Import
                    </label>
                  </div>
                  <div className="col-lg-3">
                    <div className="input-group date" id="datepicker">
                      <input
                        type="date"
                        className={`form-control`}
                        name="dateOfImport"
                        disabled
                        value={applicationDetails?.dateOfImport ?? ""}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <label htmlFor="dateExportedDate">
                          Date to be Exported
                        </label>
                      </div>
                      <div className="col-lg-6">
                        <input
                          type="date"
                          id="dateExportedDate"
                          name="dateExportedDate"
                          value={clinicalHistory?.dateExportedDate ?? ""}
                          className="form-control"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-lg-3">
                    <label className="form-check-label">
                      Sampling From Date <span className="star-red">*</span>
                    </label>
                  </div>
                  <div className="col-lg-3">
                    <input
                      type="datetime-local"
                      className={`form-control ${
                        applicationDetails?.samplingToDate &&
                        moment(applicationDetails?.samplingToDate).isBefore(
                          moment(applicationDetails?.samplingFromDate)
                        )
                          ? "border-danger"
                          : ""
                      }`}
                      name="samplingFromDate"
                      disabled
                      value={
                        applicationDetails?.samplingFromDate
                          ? moment(applicationDetails?.samplingFromDate).format(
                              "YYYY-MM-DDTHH:mm"
                            )
                          : ""
                      }
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="form-check-label">
                      Sampling To Date <span className="star-red">*</span>
                    </label>
                  </div>
                  <div className="col-lg-3">
                    <input
                      type="datetime-local"
                      className={`form-control ${
                        applicationDetails?.samplingFromDate &&
                        moment(applicationDetails?.samplingToDate).isBefore(
                          moment(applicationDetails?.samplingFromDate)
                        )
                          ? "border-danger"
                          : ""
                      }`}
                      name="samplingToDate"
                      disabled
                      value={
                        applicationDetails?.samplingToDate
                          ? moment(applicationDetails?.samplingToDate).format(
                              "YYYY-MM-DDTHH:mm"
                            )
                          : ""
                      }
                    />
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-lg-3">
                    <label htmlFor="sampledBy">
                      Sampled By
                      <span className="star-red">*</span>
                    </label>
                  </div>
                  <div className="col-lg-3">
                    <input
                      type="text"
                      id="sampledBy"
                      name="sampledBy"
                      value={applicationDetails?.sampledBy}
                      disabled
                      className="form-control"
                    />
                  </div>

                  <div className="col-lg-3">
                    <label htmlFor="crossReference">
                      Referring Veterinarian
                    </label>
                  </div>
                  <div className="col-lg-3">
                    <input
                      type="text"
                      id="referringVeterinarian"
                      name="referringVeterinarian"
                      value={applicationDetails?.referringVeterinarian}
                      className="form-control"
                      disabled
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-lg-12">
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault1"
                    >
                      <a
                        href="#"
                        className="font-weight-500"
                        onClick={handleToggleFarmDetails}
                      >
                        Farm/Location Details {showFarmDetails ? "[-]" : "[+]"}
                      </a>
                    </label>
                  </div>
                </div>
                {showFarmDetails && (
                  <>
                    {applicationDetails?.farmCode && (
                      <div className="row mb-2">
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-lg-6">
                              <label className="form-check-label" htmlFor="">
                                Farm Code
                              </label>
                            </div>
                            <div className="col-lg-6">
                              <div className="col-lg-12 mt-2">
                                <select
                                  className="form-select"
                                  aria-label="Default select example"
                                  name="farmCode"
                                  value={applicationDetails?.farmCode}
                                  disabled
                                >
                                  <option selected>-- Select --</option>
                                  {premisesCodeOptions.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                  <option
                                    key="specialFarmCode"
                                    value="specialfarmCode"
                                  >
                                    Special Farm Code
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {applicationDetails?.farmCode === "specialfarmCode" && (
                      <div className="row mb-3">
                        <div className="col-lg-6">
                          <div className="row align-items-center">
                            <div className="col-lg-6">
                              <label
                                className="form-check-label"
                                htmlFor="specialFarmCode"
                              >
                                Special Farm Code
                              </label>
                            </div>
                            <div className="col-lg-6">
                              <input
                                id="specialFarmCode"
                                type="text"
                                className="form-control"
                                disabled
                                name="specialFarmCode"
                                value={
                                  applicationDetails?.specialFarmCode || ""
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="row align-items-center">
                      <div className="col-lg-3">
                        <label htmlFor="latitude" className="mb-0">
                          Latitude (Decimal Degrees)
                        </label>
                      </div>

                      <div className="col-lg-3">
                        <input
                          type="text"
                          id="latitude"
                          name="latitude"
                          value={applicationDetails?.latitude}
                          disabled
                          className="form-control"
                          maxLength={100}
                        />
                      </div>

                      <div className="col-lg-3">
                        <label htmlFor="longitude" className="mb-0">
                          Longitude (Decimal Degrees)
                        </label>
                      </div>

                      <div className="col-lg-3">
                        <input
                          type="text"
                          id="longitude"
                          name="longitude"
                          value={applicationDetails?.longitude}
                          disabled
                          className="form-control"
                          maxLength={100}
                        />
                      </div>
                    </div>
                    <div className="row mt-2 align-items-center">
                      <div className="col-lg-3">
                        <label htmlFor="locationName">Location Name</label>
                      </div>
                      <div className="col-lg-3">
                        <input
                          type="text"
                          id="locationName"
                          name="locationName"
                          value={applicationDetails?.locationName}
                          disabled
                          className="form-control"
                          maxLength={255}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3">
                        <label
                          className="form-check-label"
                          htmlFor="addressType"
                        >
                          Farm/Location Address
                        </label>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-checked">
                          <label className="form-check-label" htmlFor="local">
                            <input
                              type="radio"
                              id="local"
                              name="addressType"
                              value="Local"
                              className="form-check-input"
                              disabled
                              checked={
                                applicationDetails?.addressType === "Local"
                              }
                            />
                            Local
                          </label>

                          <label className="form-check-label" htmlFor="foreign">
                            <input
                              type="radio"
                              id="foreign"
                              name="addressType"
                              disabled
                              value="Foreign"
                              className="form-check-input"
                              checked={
                                applicationDetails?.addressType === "Foreign"
                              }
                            />
                            Foreign
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="address">
                      <div className="row mt-2">
                        <div className="col-lg-12">
                          <div>
                            <label htmlFor="postalCode">Postal Code</label>
                            <input
                              type="text"
                              id="postalCode"
                              name="postalCode"
                              className="form-control"
                              value={applicationDetails?.postalCode}
                              disabled
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div>
                          <label htmlFor="streetName">Street/Road Name</label>
                          <input
                            type="text"
                            id="streetName"
                            name="streetName"
                            value={applicationDetails?.streetName}
                            disabled
                            className="form-control"
                            maxLength={255}
                          />
                        </div>
                      </div>

                      <div className="row mt-4">
                        <div className="col-lg-4">
                          <label htmlFor="blockHouseNo">Block/House No</label>
                          <input
                            type="text"
                            id="blockHouseNo"
                            name="blockHouseNo"
                            disabled
                            value={applicationDetails?.blockHouseNo}
                            className="form-control"
                            maxLength={255}
                          />
                        </div>
                        <div className="block">
                          <label htmlFor="level">Level</label>
                          <input
                            type="text"
                            id="level"
                            name="level"
                            value={applicationDetails?.level}
                            disabled
                            className="form-control"
                            maxLength={255}
                          />
                        </div>
                        <div className="col-lg-4">
                          <label htmlFor="unitNo">Unit No</label>
                          <input
                            type="text"
                            id="unitNo"
                            name="unitNo"
                            value={applicationDetails?.unitNo}
                            disabled
                            className="form-control"
                            maxLength={255}
                          />
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div>
                          <label htmlFor="buildingName">Building Name</label>
                          <input
                            type="text"
                            id="buildingName"
                            name="buildingName"
                            value={applicationDetails?.buildingName}
                            disabled
                            className="form-control"
                            maxLength={255}
                          />
                        </div>
                      </div>

                      <div className="row mt-4">
                        <div className="col-lg-6">
                          <label htmlFor="cityName">City Name</label>
                          <input
                            type="text"
                            id="cityName"
                            name="cityName"
                            disabled
                            value={applicationDetails?.cityName}
                            className="form-control"
                            maxLength={255}
                          />
                        </div>

                        <div className="col-lg-6">
                          <label htmlFor="State">State/Province</label>
                          <input
                            type="text"
                            id="state"
                            name="state"
                            value={applicationDetails?.state}
                            disabled
                            className="form-control"
                            maxLength={255}
                          />
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div>
                          <label htmlFor="country">Country</label>
                          <input
                            type="text"
                            id="country"
                            name="country"
                            value={applicationDetails?.country}
                            disabled
                            className="form-control"
                            maxLength={255}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className="col-lg-3">
                  <label className="form-check-label">
                    <a
                      href=""
                      className="font-weight-500"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleQuarantineInfo();
                      }}
                    >
                      Quarantine Information{" "}
                      {showQuarantineInfo ? "[-]" : "[+]"}
                    </a>
                  </label>

                  {showQuarantineInfo && (
                    <div>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              checked={clinicalHistory?.toBeExported}
                              className="form-check-input mt10"
                              disabled
                            />
                            <label className="form-check-label">
                              In Quarantine
                            </label>
                          </div>
                        </div>
                      </div>
                      {clinicalHistory?.inQuarantine && (
                        <div className="col-lg-12">
                          <div className="col-lg-9">
                            <label className="form-check-label">
                              Import Licence No
                            </label>
                          </div>
                          <input
                            type="text"
                            id="importLicenseNo"
                            name="importLicenseNo"
                            value={clinicalHistory?.importLicenseNo}
                            className="form-control"
                            disabled
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="personal-info">
          <div className="info-heading">
            <h2 className="info-h3">Clinical History &amp; Disease Signs</h2>
          </div>

          {pageLoader ? (
            <Loader />
          ) : (
            <div className="info-content">
              <div className="row">
                <div className="col-lg-2">
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault1"
                  >
                    Clinical History<span className="star-red">*</span>
                  </label>
                </div>
                <div className="col-lg-8">
                  {clinicalHistoryOptions &&
                    clinicalHistoryOptions.map((x) => {
                      return (
                        <div className="form-check form-check-inline">
                          <input
                            // className="form-check-input mt10"
                            className={`form-check-input mt10 ${
                              !clinicalHistory?.clinicalHistory
                                ? "border-danger op05"
                                : ""
                            }`}
                            type="radio"
                            name="clinicalHistory"
                            id={`${x.name}-check`}
                            value={clinicalHistory?.clinicalHistory}
                            checked={clinicalHistory?.clinicalHistory == x.id}
                            disabled
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`${x.name}-check`}
                          >
                            {x.name}
                          </label>
                        </div>
                      );
                    })}
                  {clinicalHistory?.clinicalHistory == 2 ? (
                    <div className="row">
                      <div className="col-lg-2">
                        <label className="form-check-label" htmlFor="">
                          <b>Disease Started on</b>
                        </label>
                      </div>
                      <div className="col-lg-4">
                        <div className="input-group date" id="datepicker">
                          <input
                            type="date"
                            className={`form-control`}
                            name="diseaseStartedOn"
                            value={
                              clinicalHistory?.diseaseStartedOn
                                ? moment(
                                    clinicalHistory?.diseaseStartedOn
                                  ).format("YYYY-MM-DD")
                                : ""
                            }
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 align-disease">
                        <b>OR</b>
                        <input
                          type="number"
                          className="form-control ms-2"
                          placeholder=""
                          name="ago"
                          value={clinicalHistory.ago}
                          disabled
                        />
                        <select
                          className="form-select ms-2"
                          aria-label="Default select example"
                          disabled
                          value={clinicalHistory.yearsmonth}
                        >
                          <option selected />

                          <option value={1}>Days</option>
                          <option value={2}>Weeks</option>
                          <option value={3}>Months</option>
                          <option value={4}>Years</option>
                        </select>
                        <p className="ms-2">ago</p>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-2">
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault1"
                  >
                    <a href="#" onClick={handleDiseaseSignClick}>
                      Disease Sign: [{showAdditionalContent ? "-" : "+"}]
                    </a>
                  </label>
                </div>
              </div>

              <div className="row">
                {showAdditionalContent && (
                  <div className="col-lg-12">
                    <div className="row">
                      <div className="col-lg-3">
                        <label className="form-check-label" htmlFor="">
                          Disease Pattern
                        </label>
                      </div>
                      <div className="col-lg-3">
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          name="diseasePattern"
                          value={clinicalHistory?.diseasePattern}
                          disabled
                        >
                          <option value="" disabled selected>
                            -- Select --
                          </option>
                          {diseasePatternOptions &&
                            diseasePatternOptions.map((x) => {
                              return <option value={x.id}>{x.name}</option>;
                            })}
                        </select>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-lg-3">
                        <label className="form-check-label" htmlFor="">
                          Total No. on Premises
                        </label>
                      </div>
                      <div className="col-lg-2">
                        <input
                          type="number"
                          className="form-control"
                          placeholder=""
                          name="totalNoOnPermises"
                          disabled
                          value={clinicalHistory?.totalNoOnPermises}
                        />
                      </div>
                      <div className="col-lg-1"> </div>
                      <div className="col-lg-1">
                        <label className="form-check-label" htmlFor="">
                          No. Dead Daily
                        </label>
                      </div>
                      <div className="col-lg-2">
                        <input
                          type="number"
                          className="form-control"
                          placeholder=""
                          value={clinicalHistory?.noDeadDaily}
                          name="noDeadDaily"
                          maxLength={100}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-3">
                        <label className="form-check-label" htmlFor="">
                          No. or % Diseased
                        </label>
                      </div>
                      <div className="col-lg-2">
                        <input
                          type="number"
                          className="form-control"
                          value={clinicalHistory?.noOrDisease}
                          name="noOrDisease"
                          disabled
                          placeholder=""
                        />
                      </div>
                      <div className="col-lg-1">
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          name="noOrDiseasedOptions"
                          value={clinicalHistory?.noOrDiseasedOptions}
                          disabled
                        >
                          <option selected />
                          {noOrDiseasedOptions &&
                            noOrDiseasedOptions.map((x) => {
                              return <option value={x.id}>{x.name}</option>;
                            })}
                        </select>
                      </div>

                      <div className="col-lg-1">
                        <label className="form-check-label" htmlFor="">
                          Total No. Dead
                        </label>
                      </div>
                      <div className="col-lg-2">
                        <input
                          type="number"
                          className="form-control"
                          placeholder=""
                          name="totalNoDead"
                          value={clinicalHistory?.totalNoDead}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3">
                        <label className="form-check-label" htmlFor="">
                          Farm Area
                        </label>
                      </div>
                      <div className="col-lg-2">
                        <input
                          type="number"
                          className="form-control"
                          placeholder=""
                          value={clinicalHistory?.farmArea}
                          name="farmArea"
                          disabled
                        />
                      </div>
                      <div className="col-lg-1">
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          value={clinicalHistory?.farmAreaOptions}
                          name="farmAreaOptions"
                          disabled
                        >
                          <option selected />
                          {farmAreaOptions &&
                            farmAreaOptions.map((x) => {
                              return (
                                <option value={x.id} key={x.id}>
                                  {x.name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                      <div className="col-lg-1">
                        <label className="form-check-label" htmlFor="">
                          No.Affected
                        </label>
                      </div>
                      <div className="col-lg-2">
                        <input
                          type="number"
                          className="form-control"
                          placeholder=""
                          name="noAffected"
                          value={clinicalHistory?.noAffected}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-lg-3">
                        <label className="form-check-label" htmlFor="">
                          Total No. of Units
                        </label>
                      </div>
                      <div className="col-lg-2">
                        <input
                          type="number"
                          className="form-control"
                          placeholder=""
                          value={clinicalHistory?.totalNoOfUnits}
                          name="totalNoOfUnits"
                          disabled
                        />
                      </div>
                      <div className="col-lg-1">
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          value={clinicalHistory?.noOfUnitsOptions}
                          name="noOfUnitsOptions"
                          disabled
                        >
                          <option selected />
                          {totalNoOfUnitsOptions &&
                            totalNoOfUnitsOptions.map((x) => {
                              return <option value={x.id}>{x.name}</option>;
                            })}
                        </select>
                      </div>
                      <div className="col-lg-1">
                        <label className="form-check-label" htmlFor="">
                          Unit Size
                        </label>
                      </div>
                      <div className="col-lg-2">
                        <input
                          type="number"
                          className="form-control"
                          placeholder=""
                          name="unitSize"
                          value={clinicalHistory?.unitSize}
                          disabled
                        />
                      </div>
                      <div className="col-lg-1">
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          name="unitSizeOptions"
                          value={clinicalHistory?.unitSizeOptions}
                          disabled
                        >
                          <option selected />
                          {unitSizeOptions &&
                            unitSizeOptions.map((x) => {
                              return <option value={x.id}>{x.name}</option>;
                            })}
                        </select>
                      </div>

                      <div className="col-lg-1"></div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-lg-3">
                        <label className="form-check-label" htmlFor="">
                          Age Affected
                        </label>
                      </div>
                      <div className="col-lg-2">
                        <input
                          type="number"
                          className="form-control"
                          value={clinicalHistory?.ageAffected}
                          name="ageAffected"
                          placeholder=""
                          disabled
                        />
                      </div>
                      <div className="col-lg-1">
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          value={clinicalHistory?.ageAffectedOptions}
                          name="ageAffectedOptions"
                          disabled
                        >
                          <option selected />

                          <option value={1}>days</option>
                          <option value={2}>weeks</option>
                          <option value={3}>months</option>
                          <option value={4}>years</option>
                        </select>
                      </div>
                      <div className="col-lg-1">
                        <label className="form-check-label" htmlFor="">
                          Size Affected
                        </label>
                      </div>
                      <div className="col-lg-2">
                        <input
                          type="number"
                          value={clinicalHistory?.sizeAffected}
                          name="sizeAffected"
                          className="form-control"
                          placeholder=""
                          disabled
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-lg-3">
                        <label className="form-check-label" htmlFor="">
                          Other Species/Breed Affected
                        </label>
                      </div>
                      <div className="col-lg-3">
                        <input
                          type="text"
                          value={clinicalHistory?.otherSpeciesOrBreedAff}
                          name="otherSpeciesOrBreedAff"
                          maxLength={100}
                          className="form-control"
                          placeholder=""
                          disabled
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-lg-3">
                        <label className="form-check-label" htmlFor="">
                          Clinical Signs &amp; Remarks
                        </label>
                      </div>
                      <div className="col-lg-3">
                        <textarea
                          className="form-control"
                          id="floatingTextarea"
                          placeholder=""
                          value={clinicalHistory?.clinicalSignAndRemarks}
                          name="clinicalSignAndRemarks"
                          maxLength={500}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="row">
                  <div className="col-lg-12">
                    <label
                      className="form-check-label"
                      htmlFor="vaccinationHistory"
                    >
                      <a
                        href=""
                        className="font-weight-500"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleVaccinationHistory();
                        }}
                      >
                        Vaccination History{" "}
                        {isVaccinationHistoryExpanded ? "[-]" : "[+]"}
                      </a>
                    </label>
                  </div>
                  {isVaccinationHistoryExpanded && (
                    <div className="col-lg-12">
                      <div className="col-lg-3">
                        <label className="form-check-label" htmlFor="">
                          Clinical/Vaccination History
                          <span className="star-red">*</span>
                        </label>
                      </div>
                      <textarea
                        id="vaccinationHistory"
                        name="vaccinationHistory"
                        value={clinicalHistory?.vaccinationHistory}
                        disabled
                        className={`form-control ${
                          !clinicalHistory?.vaccinationHistory
                            ? "border-danger op05"
                            : ""
                        }`}
                        required
                      ></textarea>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="info-heading mt-2">
          <h3 className="info-h3">Samples & Tests</h3>
        </div>
        {pageLoader ? (
          <Loader />
        ) : (
          samples &&
          samples.map((sample, index) => (
            <div className="personal-info">
              <div className="clonable-block" data-toggle="cloner">
                <div className="clonable" data-clone-number={1}>
                  <div className="info-heading">
                    <h2>{`Serial number ${index + 1}`}</h2>
                  </div>
                  <div className="info-content">
                    <div className="table-responsive mt-2 mb-2 ">
                      <table className="table table-striped product_table start_table">
                        <thead>
                          <tr>
                            <th className="w-20">
                              Animal Type<span className="star-red">*</span>
                            </th>
                            <th className="w-20">
                              Species/Breed<span className="star-red">*</span>{" "}
                            </th>
                            <th className="w-20">
                              Sample Description
                              <span className="star-red">*</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                value={sample.species}
                                name="species"
                                disabled
                              >
                                <option selected />
                                {speciesOptions &&
                                  speciesOptions.map((x) => {
                                    return (
                                      <option value={x.speciesName}>
                                        {x.speciesName}
                                      </option>
                                    );
                                  })}
                                <option value="Others">Others</option>
                              </select>

                              {sample.species === "Others" && (
                                <input
                                  type="text"
                                  className="form-control mt-2"
                                  value={sample.otherSpecies}
                                  name="otherSpecies"
                                  disabled
                                />
                              )}
                            </td>
                            <td>
                              {" "}
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                value={sample.breed}
                                name="breed"
                                disabled
                              >
                                <option selected />
                                {breedOptions &&
                                  breedOptions.map((x) => {
                                    return (
                                      <option value={x.breedName}>
                                        {x.breedName}
                                      </option>
                                    );
                                  })}
                                <option value="Others">Others</option>
                              </select>
                              {sample.breed === "Others" && (
                                <input
                                  type="text"
                                  className="form-control mt-2"
                                  name="otherBreed"
                                  value={sample.otherBreed}
                                  disabled
                                />
                              )}
                            </td>
                            <td>
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                value={sample.specimenDescription}
                                name="specimenDescription"
                                disabled
                              >
                                <option selected />
                                {specimenOptions &&
                                  specimenOptions.map((x) => {
                                    return (
                                      <option value={x.labSpecimenDescription}>
                                        {x.labSpecimenDescription}
                                      </option>
                                    );
                                  })}
                                <option value="Others">Others</option>
                              </select>

                              {sample.specimenDescription === "Others" && (
                                <input
                                  type="text"
                                  className="form-control mt-2"
                                  name="otherSpecimenDescription"
                                  value={sample.otherSpecimenDescription}
                                  disabled
                                />
                              )}
                            </td>
                          </tr>

                          <tr>
                            <td className="fnt-wg tr-ignore">
                              <div className="mb-3 ">
                                <div className="mb-2">
                                  <label
                                    htmlFor="staticEmail"
                                    className="col-form-label"
                                  >
                                    Sample Marking{" "}
                                    <span className="star-red">*</span>
                                  </label>
                                  <div className="input-group date">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder=""
                                      name="sampleMarking"
                                      value={sample?.sampleMarking}
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="fnt-wg tr-ignore">
                              <div className="mb-3 ">
                                <div className="mb-2">
                                  <label
                                    htmlFor="staticEmail"
                                    className="col-form-label"
                                  >
                                    Test Information{" "}
                                    <span className="star-red">*</span>
                                  </label>
                                  <div className="input-group date">
                                    <button
                                      className={`btn btn-outline-success w-100 ${
                                        sample?.labAquaTestDetailErrMsg
                                          ? "border-danger"
                                          : ""
                                      }`}
                                      type="button"
                                      data-bs-toggle="modal"
                                      data-bs-target="#staticBackdrop1"
                                      disabled
                                    >
                                      Search Test
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>

                          {/*<tr>
                            <td className="fnt-wg tr-ignore">
                              <div className="mb-3 ">
                                <div className="mb-2">
                                  <label
                                    htmlFor="staticEmail"
                                    className="col-form-label"
                                  >
                                    Latitude (Decimal Degrees)
                                  </label>
                                  <div className="input-group date">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder=""
                                      name="latitude"
                                      value={sample?.latitude}
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </td>

                            <td className="fnt-wg tr-ignore">
                              <div className="mb-3 ">
                                <div className="mb-2">
                                  <label
                                    htmlFor="staticEmail"
                                    className="col-form-label"
                                  >
                                    Longitude (Decimal Degrees)
                                  </label>
                                  <div className="input-group date">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder=""
                                      name="longitude"
                                      value={sample?.longitude}
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>*/}

                          {sample.labAquaTestDetail &&
                            sample.labAquaTestDetail
                              .filter((test) => test.testDescription !== "")
                              .map((test, testIndex) => (
                                <tr key={`test-row-${index}-${testIndex}`}>
                                  <td className="br-1" colSpan={2}>
                                    <div className="mb-3">
                                      <div className="mb-2">
                                        <div className="test-detail">
                                          <div
                                            id={`testDescription-${index}-${test.labTestID}`}
                                            className="test-description"
                                            dangerouslySetInnerHTML={{
                                              __html: test.testDescription,
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="fnt-wg tr-ignore">
                                    <div className="mb-3">
                                      <div className="mb-2">
                                        <label
                                          htmlFor={`repeatCount-${index}-${testIndex}`}
                                          className="col-form-label float-start"
                                        >
                                          Number of Tests
                                          <span className="star-red">*</span>
                                        </label>
                                        <div className="input-group date">
                                          <input
                                            type="number"
                                            id={`repeatCount-${index}-${testIndex}`}
                                            min="1"
                                            className="form-control"
                                            value={test.noOfTestsRequired ?? 1}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))}

                          {sample.labAquaTestDetail && (
                            <>
                              {sample.labAquaTestDetail.some(
                                (test) =>
                                  test.testMethodSOPDescription
                                    ?.trim()
                                    .toLowerCase() === "post-mortem"
                              ) && (
                                <tr>
                                  <td colSpan={5}>
                                    <div className="col-lg-12">
                                      <label
                                        className="form-check-label"
                                        htmlFor="flexRadioDefault1"
                                      >
                                        <a
                                          href=""
                                          className="font-weight-500"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setShowPostMortem(!showPostMortem);
                                          }}
                                        >
                                          For Post Mortem:{" "}
                                          {showPostMortem ? "[-]" : "[+]"}
                                        </a>
                                      </label>

                                      {showPostMortem && (
                                        <>
                                          <div className="row">
                                            <div className="col-lg-4">
                                              <label
                                                htmlFor="postMortemConsentForms"
                                                className="form-check-label"
                                              >
                                                Post-Mortem Consent Form
                                                <span className="star-red">
                                                  *
                                                </span>
                                              </label>

                                              <div className="col-lg-12">
                                                {sample?.postMortemConsentFormName ? (
                                                  <div className="file-view">
                                                    {
                                                      sample?.postMortemConsentFormName
                                                    }
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                            </div>
                                            <div className="col-lg-4">
                                              <label className="form-check-label">
                                                Save Remains for
                                                Burial/Cremation
                                                <span className="star-red">
                                                  *
                                                </span>
                                              </label>
                                              <div className="form-checked">
                                                <select
                                                  id="saveRemains"
                                                  name="saveRemains"
                                                  className="form-select"
                                                  value={
                                                    sample?.saveRemains || ""
                                                  }
                                                  disabled
                                                >
                                                  <option value="">
                                                    Select an option
                                                  </option>
                                                  <option value="yes">
                                                    Yes
                                                  </option>
                                                  <option value="No">No</option>
                                                </select>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="row">
                                            <div className="col-lg-4">
                                              <label
                                                className="form-check-label"
                                                htmlFor="Remarks"
                                              >
                                                Remarks
                                              </label>
                                              <textarea
                                                className="form-control"
                                                name="remarks"
                                                value={sample?.remarks || ""}
                                                disabled
                                              />
                                            </div>
                                          </div>
                                          <div className="form-check col-lg-12">
                                            <input
                                              type="checkbox"
                                              className="form-check-input mt10"
                                              id="euthanised"
                                              checked={sample?.euthanised}
                                              disabled
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor="euthanised"
                                            >
                                              Euthanised
                                            </label>
                                          </div>

                                          {sample?.euthanised && (
                                            <>
                                              <div className="col-lg-3">
                                                <label
                                                  htmlFor="euthanisedDate"
                                                  className="form-check-label"
                                                >
                                                  Euthanised Date
                                                </label>
                                                <input
                                                  type="date"
                                                  id="euthanisedDate"
                                                  name="euthanisedDate"
                                                  value={
                                                    sample?.euthanisedDate
                                                      ? moment(
                                                          sample?.euthanisedDate
                                                        ).format("YYYY-MM-DD")
                                                      : ""
                                                  }
                                                  disabled
                                                  className="form-control"
                                                />
                                              </div>

                                              <div className="col-lg-3">
                                                <label
                                                  htmlFor="methodofEuthanised"
                                                  className="col-form-label"
                                                >
                                                  Method of Euthanasia
                                                </label>
                                                <input
                                                  type="text"
                                                  id="methodofEuthanised"
                                                  name="methodofEuthanised"
                                                  value={
                                                    sample?.methodofEuthanised ||
                                                    ""
                                                  }
                                                  className="form-control"
                                                  disabled
                                                />
                                              </div>
                                            </>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </>
                          )}
                          <div className="col-lg-12">
                            <label
                              className="form-check-label"
                              htmlFor="flexRadioDefault1"
                            >
                              <a
                                href=""
                                className="font-weight-500"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowGroupAnimals(!showGroupAnimals);
                                }}
                              >
                                For Group Animals:{" "}
                                {showGroupAnimals ? "[-]" : "[+]"}
                              </a>
                            </label>
                          </div>
                          {showGroupAnimals && (
                            <>
                              <tr>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3 ">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="staticEmail"
                                        className="col-form-label"
                                      >
                                        No. on Premises
                                      </label>
                                      <div className="input-group date">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={sample.noOnPremises}
                                          name="noOnPremises"
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3 ">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="staticEmail"
                                        className="col-form-label"
                                      >
                                        No. in Group/Pen
                                      </label>
                                      <div className="input-group date">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={sample.noInGroup}
                                          name="noInGroup"
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3 ">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="staticEmail"
                                        className="col-form-label"
                                      >
                                        No. Sick
                                      </label>
                                      <div className="input-group date">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={sample.noSick}
                                          name="noSick"
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3 ">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="staticEmail"
                                        className="col-form-label"
                                      >
                                        No. Dead
                                      </label>
                                      <div className="input-group date">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={sample.noDead}
                                          name="noDead"
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3 ">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="staticEmail"
                                        className="col-form-label"
                                      >
                                        No. at Risk
                                      </label>
                                      <div className="input-group date">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={sample.noAtRisk}
                                          name="noAtRisk"
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3 ">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="staticEmail"
                                        className="col-form-label"
                                      >
                                        Herd/Group ID
                                      </label>
                                      <div className="input-group date">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={sample.groupID}
                                          name="groupID"
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3 ">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="staticEmail"
                                        className="col-form-label"
                                      >
                                        House/Pen No
                                      </label>
                                      <div className="input-group date">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={sample.penNo}
                                          name="penNo"
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </>
                          )}
                          <div className="col-lg-12">
                            <label className="form-check-label">
                              <a
                                href="#"
                                className="font-weight-500"
                                onClick={handleToggleAnimalDetails}
                              >
                                For Individual Animal{" "}
                                {animalDetails ? "[-]" : "[+]"}
                              </a>
                            </label>
                          </div>
                          {animalDetails && (
                            <>
                              <tr>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3 ">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="staticEmail"
                                        className="col-form-label"
                                      >
                                        Owner
                                      </label>
                                      <div className="input-group date">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={sample.owner}
                                          name="owner"
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3 ">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="staticEmail"
                                        className="col-form-label"
                                      >
                                        Name of Animal
                                      </label>
                                      <div className="input-group date">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={sample.nameofAnimal}
                                          name="nameofAnimal"
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3 ">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="staticEmail"
                                        className="col-form-label"
                                      >
                                        ID/Microchip No.
                                      </label>
                                      <div className="input-group date">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={sample.microchipNo}
                                          name="microchipNo"
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3 ">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="staticEmail"
                                        className="col-form-label"
                                      >
                                        Date of Birth
                                      </label>
                                      <div className="input-group date">
                                        <input
                                          type="date"
                                          className="form-control"
                                          value={sample?.dateofBirth ?? ""}
                                          name="dateofBirth"
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="Sterilized"
                                        className="col-form-label"
                                      >
                                        Sterilized
                                      </label>

                                      <select
                                        className="form-select"
                                        name="sterilized"
                                        disabled
                                        value={sample?.sterilized}
                                        aria-label="Default select example"
                                      >
                                        <option selected> -- Select --</option>

                                        <option value={1}>Yes</option>
                                        <option value={2}> No</option>
                                        <option value={3}>Unknown</option>
                                      </select>
                                    </div>
                                  </div>
                                </td>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="countryOfResidence"
                                        className="col-form-label"
                                      >
                                        Country of Residence
                                      </label>

                                      <Select
                                        options={countryOptions}
                                        value={countryOptions.find(
                                          (option) =>
                                            option.value ===
                                            sample.countryofResidence
                                        )}
                                        isDisabled
                                      />
                                    </div>
                                  </div>
                                </td>
                              </tr>

                              <tr>
                                <td className="fnt-wg tr-ignore">
                                  <div className="mb-3">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="gender"
                                        className="col-form-label"
                                      >
                                        Sex
                                      </label>
                                      <div className="input-group">
                                        <label
                                          className="form-check-label me-2"
                                          htmlFor="male"
                                        >
                                          <input
                                            type="radio"
                                            id={`male-${index}`}
                                            name={`gender-${index}`}
                                            value="Male"
                                            disabled
                                            checked={sample?.gender === "Male"}
                                            className="form-check-input"
                                          />
                                          Male
                                        </label>

                                        <label
                                          className="form-check-label me-2"
                                          htmlFor="female"
                                        >
                                          <input
                                            type="radio"
                                            id={`female-${index}`}
                                            name={`gender-${index}`}
                                            value="Female"
                                            disabled
                                            checked={
                                              sample?.gender === "Female"
                                            }
                                            className="form-check-input"
                                          />
                                          Female
                                        </label>

                                        <label
                                          className="form-check-label"
                                          htmlFor="unknown"
                                        >
                                          <input
                                            type="radio"
                                            id={`unknown-${index}`}
                                            name={`gender-${index}`}
                                            value="unknown"
                                            disabled
                                            checked={
                                              sample?.gender === "unknown"
                                            }
                                            className="form-check-input"
                                          />
                                          Unknown
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td colSpan={2} className="fnt-wg tr-ignore">
                                  <div className="mb-3">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="age"
                                        className="col-form-label"
                                      >
                                        Age
                                      </label>
                                      <div className="input-group">
                                        <div className="row">
                                          <div className="col-lg-3">
                                            <label className="form-label">
                                              Years
                                            </label>
                                            <input
                                              type="number"
                                              className="form-control"
                                              name="years"
                                              value={sample?.years}
                                              disabled
                                              placeholder="yrs"
                                            />
                                          </div>
                                          <div className="col-lg-3">
                                            <label className="form-label">
                                              Months
                                            </label>
                                            <input
                                              type="number"
                                              className="form-control"
                                              name="months"
                                              value={sample?.months}
                                              disabled
                                              placeholder="mths"
                                            />
                                          </div>
                                          <div className="col-lg-3">
                                            <label className="form-label">
                                              Weeks
                                            </label>
                                            <input
                                              type="number"
                                              className="form-control"
                                              name="weeks"
                                              value={sample?.weeks}
                                              disabled
                                              placeholder="weeks"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
        <div className="info-heading">
          <h3 className="info-h3">My Preference</h3>
        </div>
        <div className="personal-info">
          <div className="clonable-block">
            <div className="clonable">
              <div className="info-content">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-5">
                        <label
                          className="form-check-label"
                          htmlFor="SpecialInstructions"
                        >
                          For Bacterial Culture Only
                        </label>
                      </div>
                      <div className="col-lg-7 d-flex align-items-center">
                        <input
                          type="checkbox"
                          className="form-check-input me-2"
                          disabled
                          name="antimicrobialSusceptibilityTestRequired"
                          checked={
                            myPreference?.antimicrobialSusceptibilityTestRequired
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="antimicrobialSusceptibilityTestRequired"
                        >
                          Antimicrobial Susceptibility Test Required
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-5">
                        <label
                          className="form-check-label"
                          htmlFor="specialInstructions"
                        >
                          Special Instructions/ Additional Information
                        </label>
                      </div>
                      <div className="col-lg-7">
                        <textarea
                          className="form-control"
                          name="specialInstructions"
                          value={myPreference?.specialInstructions}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row mt-2 mt-lg-0">
                      <div className="col-lg-5">
                        <label
                          className="form-check-label"
                          htmlFor="otherRemarks"
                        >
                          Other Remarks
                        </label>
                      </div>
                      <div className="col-lg-7">
                        <textarea
                          className="form-control"
                          name="resultReportingInstr"
                          value={myPreference?.remarks}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-5">
                        <label
                          className="form-check-label"
                          htmlFor="supportDocuments"
                        >
                          Support Documents
                        </label>
                      </div>
                      <div className="col-lg-7">
                        <div className="file-view mt-2">
                          {myPreference?.supportDocumentName
                            ? myPreference.supportDocumentName
                            : "No file attached"}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 mt-3">
                    <div className="row">
                      <div className="col-lg-5">
                        <label
                          className="form-check-label"
                          htmlFor="modeOfReceiving"
                        >
                          Mode of receiving report
                          <span className="star-red">*</span>
                        </label>
                      </div>
                      <div className="col-lg-7">
                        <select
                          name="modeOfReceiving"
                          disabled
                          value={myPreference?.modeOfReceiving}
                          className="form-select"
                          aria-label="Mode of receiving report"
                        >
                          <option value="" disabled>
                            Select an option
                          </option>
                          <option value={2}>Email</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {myPreference?.modeOfReceiving === 1 && (
                    <div className="row mt-2">
                      <div className="col-lg-6">
                        <label className="form-check-label fw-bold mb-2">
                          Please select the address for mailing:
                        </label>
                        <select
                          name="mailingAddress"
                          className="form-select mb-3"
                          value={myPreference?.mailingAddress}
                          disabled
                        >
                          <option value="" disabled hidden>
                            Please Select address
                          </option>
                          <option value={1}>Same as mailing address</option>
                          <option value={2}>Same as billing address</option>
                          <option value={3}>Others (please specify)</option>
                        </select>

                        {myPreference?.mailingAddress === 3 && (
                          <div className="col-lg-12">
                            <textarea
                              className="form-control mt-2"
                              placeholder="Enter address"
                              name="customAddress"
                              disabled
                              value={myPreference?.customAddress}
                            />
                          </div>
                        )}

                        <div className="alert alert-warning mt-3">
                          Please note that NParks is not liable for lost mail,
                          and any additional copies of laboratory reports are
                          subject to additional charges.
                        </div>

                        <div className="form-check mt-3">
                          <input
                            type="checkbox"
                            className="form-check-input mt-2"
                            id="acknowledgeCheckbox"
                            name="acknowledge"
                            disabled
                            checked={myPreference?.acknowledge || false}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="acknowledgeCheckbox"
                          >
                            I acknowledge the above information
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-end mt-3 mb-3">
          <button
            className="btn btn-d btn-secondary px-4"
            onClick={handlePreviousClick}
          >
            Previous
          </button>
          <button
            className="btn btn-d btn-primary nextBtn"
            name="next-click"
            type="button"
            onClick={handleNextClick}
          >
            Next
          </button>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default CAVSAquaReview;
